/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateGcpIamPlatformCredentialRequestBody,
  UpdateGcpIamPlatformCredentialRequestBody$Outbound,
  UpdateGcpIamPlatformCredentialRequestBody$outboundSchema,
} from "../components/updategcpiamplatformcredentialrequestbody.js";

export type UpdateGcpIamPlatformCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateGcpIamPlatformCredentialRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateGcpIamPlatformCredentialRequestBody:
    UpdateGcpIamPlatformCredentialRequestBody;
};

/** @internal */
export type UpdateGcpIamPlatformCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateGcpIamPlatformCredentialSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateGcpIamPlatformCredentialSecurity$Outbound,
    UpdateGcpIamPlatformCredentialSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateGcpIamPlatformCredentialSecurityToJSON(
  updateGcpIamPlatformCredentialSecurity:
    UpdateGcpIamPlatformCredentialSecurity,
): string {
  return JSON.stringify(
    UpdateGcpIamPlatformCredentialSecurity$outboundSchema.parse(
      updateGcpIamPlatformCredentialSecurity,
    ),
  );
}

/** @internal */
export type UpdateGcpIamPlatformCredentialRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateGcpIamPlatformCredentialRequestBody:
    UpdateGcpIamPlatformCredentialRequestBody$Outbound;
};

/** @internal */
export const UpdateGcpIamPlatformCredentialRequest$outboundSchema:
  z.ZodMiniType<
    UpdateGcpIamPlatformCredentialRequest$Outbound,
    UpdateGcpIamPlatformCredentialRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      updateGcpIamPlatformCredentialRequestBody:
        UpdateGcpIamPlatformCredentialRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        updateGcpIamPlatformCredentialRequestBody:
          "UpdateGcpIamPlatformCredentialRequestBody",
      });
    }),
  );

export function updateGcpIamPlatformCredentialRequestToJSON(
  updateGcpIamPlatformCredentialRequest: UpdateGcpIamPlatformCredentialRequest,
): string {
  return JSON.stringify(
    UpdateGcpIamPlatformCredentialRequest$outboundSchema.parse(
      updateGcpIamPlatformCredentialRequest,
    ),
  );
}
